import { notification } from "antd";
import React from "react";

export const adnNotification = (
  message,
  description,
  type = "error",
  duration = 5
) => {
  notification[type]({
    message: message,
    description: description,
    placement: "topRight",
    duration: duration,
  });
};
